export const EducationData = [
    {
        subtext : 'UCLA / B.S. Computer Science : 2021-2025',
        left : [
            'Relevant courses:',
            'Data Structures and Algorithms, Software Construction, Discrete Math, Linear Algebra, Operating Systems, Neural Networks and Deep Learning',
            ],
        right : ['GPA: 3.8']
    },
];